import useWindowSize from '@/src/hooks/useResponsive';
import styles from './FundDetailsLoader.module.scss';
import { EYE_HIDE } from "@/src/lib/SmartDB/Commons/Constants/images";
import FundDataLoader from './FundData/FundDataLoader';
import ChartContainerLoader from './ChartContainer/ChartContainerLoader';
import TokenDetailsLoader from './TokensDetails/TokenDetailsLoader';

export default function FundDetailsLoader() {
    const { width } = useWindowSize();
    const isTablet = width < 900;
    const isDesktop = width > 1100;
    return (
        <main className={styles.fundsDetailsSection}>
            <section className={styles.fundSection}>
                <FundDataLoader isTablet={isTablet} isDesktop={isDesktop} />
                <ChartContainerLoader isDesktop={isDesktop} />
                <TokenDetailsLoader isTablet={isTablet} isDesktop={isDesktop} />
            </section>
        </main>
    );
}
